import { render, staticRenderFns } from "./DialogVideoList.vue?vue&type=template&id=eb248192&"
import script from "./DialogVideoList.vue?vue&type=script&lang=js&"
export * from "./DialogVideoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports